export const getNotifications = (userId) => {
  const key = `notifications_${userId}`;
  const stored = localStorage.getItem(key);
  return stored ? JSON.parse(stored) : [];
};

export const saveNotifications = (userId, notifications) => {
  const key = `notifications_${userId}`;
  localStorage.setItem(key, JSON.stringify(notifications));
};

export const addNotification = (userId, notification) => {
  const notifications = getNotifications(userId);
  const updated = [notification, ...notifications].slice(0, 10);
  saveNotifications(userId, updated);
};

export const markAllNotificationsAsRead = (userId) => {
  const notifications = getNotifications(userId);
  const updated = notifications.map((n) => ({ ...n, read: true }));
  saveNotifications(userId, updated);

  return updated;
};
